import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

interface Emoji {
    name: string;
    rating: number;
    assetPath: string;
}

interface FeedbackData {
    tripId?: string;
    rating: number;
    emojiName: string;
    feedback: {
        rating: number;
        emotion: string;
    };
}

@Component({
    selector: 'app-trip-reviews',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    templateUrl: './trip-reviews.component.html',
    styleUrls: ['./trip-reviews.component.scss']
})
export class TripReviewsComponent implements OnInit {
    @Input() tripId?: string;
    @Output() feedbackSubmitted = new EventEmitter<FeedbackData>();
    
    selectedEmoji: Emoji | null = null;
    isSubmitting = false;

    private translate = inject(TranslateService);

    emojis: Emoji[] = [
         { name: 'happy', rating: 5, assetPath: 'avatars/6.webp' },
         { name: 'lovely', rating: 4, assetPath: 'avatars/5.webp' },
         { name: 'cool', rating: 3, assetPath: 'avatars/4.webp' },
         { name: 'confused', rating: 2, assetPath: 'avatars/3.webp' },
         { name: 'disappointed', rating: 1, assetPath: 'avatars/2.webp' },
         { name: 'crying', rating: 0, assetPath: 'avatars/1.webp' },

    ];
    
    constructor() { }

    ngOnInit(): void {
        this.loadReviews();
    }

    loadReviews(): void {

    }

    selectEmoji(emoji: Emoji): void {
        this.selectedEmoji = emoji;
    }

    isEmojiSelected(emoji: Emoji): boolean {
        return this.selectedEmoji?.name === emoji.name;
    }

    submitFeedback(): void {
        if (!this.selectedEmoji || this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;
        
        const feedbackData: FeedbackData = {
            tripId: this.tripId,
            rating: this.selectedEmoji.rating,
            emojiName: this.selectedEmoji.name,
            feedback: {
                rating: this.selectedEmoji.rating,
                emotion: this.selectedEmoji.name
            }
        };

        // Émettre l'événement vers le composant parent
        this.feedbackSubmitted.emit(feedbackData);
        
        // Simuler un petit délai pour l'UX
        setTimeout(() => {
            this.isSubmitting = false;
            // Reset selection after submission
            this.selectedEmoji = null;
            console.log('Feedback data emitted:', feedbackData);
            
            // Optionnel: Afficher un message de succès
            console.log(this.translate.instant('TRIP_REVIEWS.FEEDBACK_SUCCESS'));
        }, 500);
    }

    getEmojiAlt(emojiName: string): string {
        return this.translate.instant('TRIP_REVIEWS.EMOJI_ALT', { name: emojiName });
    }


}